import React, { FC } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';

import { ReactComponent as MenuIcon } from '@pharmaplan/common/assets/icons/menuIcon.svg';

import { ReactComponent as DiscountIcon } from '../../../assets/svg/discountIcon.svg';
import { ChipType, SkeletonVariants } from '../../../helpers/Constants';
import CustomMenuList from '../../common/CustomMenuList';
import CustomChip from '../../common/CustomChip';
import strings from '../../../localization';

import styles from './styles';
import withSkeleton from '../../common/WithSkeleton';

export type genericFunction = () => void;

interface IWorkshiftDiscountRightSection {
  menuActions: Array<{
    key: string;
    label: string;
    onClick: genericFunction;
  }> | null;
  hourlyRate?: number;
  strikeRate?: number | null;
  successAction: string;
  showDiscountIcon?: boolean;
  discountTooltip?: string;
}

const WorkshiftDiscountRightSection: FC<IWorkshiftDiscountRightSection> = ({
  showDiscountIcon,
  discountTooltip,
  successAction,
  menuActions,
  hourlyRate,
  strikeRate,
}) => {
  const SkeletonTypography = withSkeleton({
    successAction,
    variant: SkeletonVariants.text,
  })(Typography);

  return (
    <>
      {menuActions && (
        <Box sx={styles.menuContainer}>
          {!!showDiscountIcon && (
            <Box>
              <Tooltip title={discountTooltip}>
                <DiscountIcon />
              </Tooltip>
            </Box>
          )}
          <CustomMenuList
            margin={10}
            disableFixedDropdown
            customMenuTextStyle={styles.menuText}
            customIconButtonStyle={styles.button}
            items={menuActions}
          >
            <MenuIcon height={24} width={24} />
          </CustomMenuList>
        </Box>
      )}
      <Box sx={styles.strikeContainer}>
        {!!strikeRate && (
          <SkeletonTypography sx={styles.strikeText}>
            {`$${strikeRate}${strings.perHour}`}
          </SkeletonTypography>
        )}
        {!!hourlyRate && (
          <CustomChip
            label={`$${hourlyRate}${strings.perHour}`}
            type={ChipType.hourlyRate}
          />
        )}
      </Box>
    </>
  );
};
export default WorkshiftDiscountRightSection;
